<template>
  <div class="ui-kit">
    <h1>UI-KIT</h1>
    <button class="ui-kit__menu-button" @click="isOpenMenu = !isOpenMenu">
      {{ btnMenuText }}
    </button>
    <collapse-transition>
      <div v-show="isOpenMenu">
        <ul class="ui-kit__menu">
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/main">
              Главная
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/grid">
              Сетка
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/buttons">
              Кнопки
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/modals">
              Модальные окна
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/curtains">
              Шторки
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/calendars">
              Календари
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/dropdowns">
              Dropdowns
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/widgets">
              Виджеты
            </router-link>
          </li>
          <li class="ui-kit__menu-item">
            <router-link class="ui-kit__menu-link" to="/ui-kit/controls">
              Controls
            </router-link>
          </li>
        </ul>
      </div>
    </collapse-transition>
    <hr class="ui-kit__line" />
    <router-view :key="$route.name" />
  </div>
</template>

<script>
import { CollapseTransition } from 'vue2-transitions';

export default {
  name: 'UiKitLayout',
  components: { CollapseTransition },
  data: () => ({
    isOpenMenu: false,
  }),
  computed: {
    btnMenuText() {
      return this.isOpenMenu ? 'Закрыть меню' : 'Открыть меню';
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-kit {
  &__menu {
    @include list-reset;

    padding-left: 20px;
  }

  &__menu-link {
    @include link;
  }

  &__menu-button {
    @include button-reset;

    margin-top: 20px;
  }

  &__line {
    margin-bottom: 20px;
  }
}
</style>
